'use client';

import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslations } from '@/lib/i18n';

export default function StatsBar() {
  const { language } = useLanguage();
  const stats = getTranslations(language)?.stats;

  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref?.current) obs?.observe(ref?.current);
    return () => obs?.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="section-glow border-y border-dispatch-surface/60 bg-dispatch-surface/20 py-10"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 stagger-grid" data-observe>
          {stats?.map((s, i) => (
            <div
              key={i}
              className={`text-center stagger-grid ${visible ? 'is-visible' : ''}`}
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              <p className="font-manrope font-extrabold text-dispatch-cyan text-2xl tracking-tight">{s?.value}</p>
              <p className="font-mono text-dispatch-faint text-[10px] uppercase tracking-widest mt-1">{s?.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}